<template>
  <v-carousel cycle hide-delimiters show-arrows-on-hover>
    <v-carousel-item v-for="(image, index) in images" :key="index">
      <router-link to="/other-projects" style="text-decoration: none;">
        <v-img :src="image" class="fill-height" />
      </router-link>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('../../assets/dashboard_sliders/ilksms-gorsel-700x450.png'),
        require('../../assets/dashboard_sliders/kolaydernek-gorseli-700x450.png'),
        require('../../assets/dashboard_sliders/salonrandevu-gorsel-700x450.png'),
        require('../../assets/dashboard_sliders/vayonet-gorseli-700x450.png'),
        // Diğer statik görselleri buraya ekleyebilirsiniz
      ],
      links: [
        'https://ilksms.com', // İlk görselin linki
        'https://kolaydernek.com', // İkinci görselin linki
        'https://salonrandevu.com', // Üçüncü görselin linki
        'https://vayonet.com', // Dördüncü görselin linki
      ],
    };
  },
};
</script>

<style>
.v-carousel-item {
  max-height: 450px;
  max-width: 700px;
}

@media only screen and (max-width: 2540px) {
  .v-image__image--cover{
    background-size: contain;
  }
}
</style>